import { useSelector } from 'react-redux'
import Styles from './ListRow.module.scss'
import { TreeFile } from 'screens/Finder/FinderContextTypes'
import { RootState } from 'types'
import { isEqual } from 'lodash/fp'
import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import { useFinderContext } from 'screens/Finder/FinderContext'
import { DefaultType, Property, PropertyType, PropertyValue } from 'api/clients/PropertyClient'
import Person from 'common/PropertyValue/Types/Person'
import { forwardRef } from 'react'
import { sortBy } from 'lodash'
import { Text } from 'blaze-ui/Text/Text'

dayjs.extend(advancedFormat)

export const reorderProperties = (properties: Property<PropertyValue>[]) => {
  const propertyPrecedence = ['created', 'updated', 'owner']

  const precedence = (p: Property<PropertyValue>) => {
    return propertyPrecedence.indexOf(p.default_type || p.type)
  }
  return sortBy(properties, precedence)
}

interface ListPropertyProps {
  file: TreeFile
  property: Property<PropertyValue>
}

const ListProperty = forwardRef<HTMLDivElement, ListPropertyProps>(({ file, property }, ref) => {
  const propertyValues = useSelector(({ filesProperties }: RootState) => {
    return property && filesProperties[file.id]?.[property.id as number]?.values
  }, isEqual)

  if (!propertyValues || !propertyValues.length) return <div />

  if (property.type === PropertyType.Person) {
    return <Person propertyValue={propertyValues[0]} userClassName={Styles.person} />
  }

  if (property.type === PropertyType.Date) {
    return (
      <div>
        <Text variant="secondary" color="var(--dark-80)">
          {dayjs(propertyValues[0].value).format('MMM Do, h:mm a')}
        </Text>
      </div>
    )
  }

  return <div />
})

interface Props {
  file: TreeFile
}

const ListProperties = ({ file }: Props) => {
  const { filesView } = useFinderContext()

  const properties = filesView?.schema.properties
  const orderedProperties = (properties ? reorderProperties(properties) : []).filter((prop) =>
    [DefaultType.Owner, DefaultType.Updated, DefaultType.Created].includes(prop.default_type as DefaultType),
  )

  return (
    <>
      {orderedProperties.map((p) => (
        <div className={Styles.property} key={`${file.id}-${p.id}`}>
          <ListProperty file={file} property={p} />
        </div>
      ))}
    </>
  )
}

export { ListProperties }
